import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ShowLessIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M8 8V5H10V10H5V8H8Z' fill='currentColor' />
            <Path d='M8 16V19H10V14H5V16H8Z' fill='currentColor' />
            <Path d='M16 8V5H14V10H19V8H16Z' fill='currentColor' />
            <Path d='M16 16V19H14V14H19V16H16Z' fill='currentColor' />
        </>
    ),
})

ShowLessIcon.displayName = 'ShowLessIcon'
